/**
 * Tarjeta de contenido con cabecera y cuerpo colapsable (altura vía CSS grid).
 */

export default class ContentCard {
	private root: HTMLElement
	private header: HTMLElement | null = null
	private body: HTMLElement | null = null
	private bound = false

	constructor(root: HTMLElement) {
		this.root = root
	}

	static syncContentCardSkin(root: HTMLElement, expanded: boolean): void {
		const closed = root.dataset.hgCcCollapsed
		const open = root.dataset.hgCcExpanded
		if (!closed || !open || closed === open) return

		root.classList.remove(`is-${closed}`, `is-${open}`)
		root.classList.add(`is-${expanded ? open : closed}`)
	}

	init() {
		if (!this.root.classList.contains('is-collapsible')) return

		const block = this.root.classList.contains('hg-content-card-gradient')
			? 'hg-content-card-gradient'
			: 'hg-content-card'

		this.header = this.root.querySelector<HTMLElement>(`:scope > .${block}__header`)
		this.body = this.root.querySelector<HTMLElement>(`:scope > .${block}__body`)

		if (!this.header || !this.body) return

		this.header.addEventListener('click', this.onHeaderClick)
		this.bound = true
	}

	cleanup() {
		if (this.bound && this.header) {
			this.header.removeEventListener('click', this.onHeaderClick)
		}
		this.bound = false
	}

	private onHeaderClick = () => {
		if (!this.header || !this.body) return

		const isExpanded = this.header.getAttribute('aria-expanded') === 'true'

		if (isExpanded) {
			this.body.setAttribute('inert', '')
			this.header.setAttribute('aria-expanded', 'false')
			this.root.classList.remove('is-expanded')
			this.root.classList.add('is-collapsed')
			ContentCard.syncContentCardSkin(this.root, false)
		} else {
			this.body.removeAttribute('inert')
			this.header.setAttribute('aria-expanded', 'true')
			this.root.classList.add('is-expanded')
			this.root.classList.remove('is-collapsed')
			ContentCard.syncContentCardSkin(this.root, true)
		}

		window.setTimeout(() => {
			document.dispatchEvent(new CustomEvent('hg:refresh-scroll'))
		}, 450)
	}
}
